// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__LQCru","tab":"styles_tab__PrLeS","containerContent":"styles_containerContent__uvh+0","active":"styles_active__VEoGp","singleTab":"styles_singleTab__HgN8a"};